export enum RemedialActionTypeEnum {
  Complete = 1,
  Postpone = 2,
}
